import { Children, ComponentClass, createElement, FunctionComponent, HtmlHTMLAttributes, memo, NamedExoticComponent, ReactNode } from "react";
import classnames from "classnames";
import { TabsContainer } from "./Tabs";

import styles from "./style.module.scss";


export type FormLayoutProps = {
  header?: ReactNode;
  headerClassName?: string,
  contentClassName?: string,
  tabsContainerComponent?: string | FunctionComponent | ComponentClass | NamedExoticComponent
} & HtmlHTMLAttributes<HTMLDivElement>

export const FormLayout = memo<FormLayoutProps>((
  {
    children,
    header,
    className,
    headerClassName,
    contentClassName,
    tabsContainerComponent = TabsContainer,
    ...props
  }) => {

  return (
    <div className={classnames(styles.root, className)} {...props}>
      {
        Children.count(header) > 0 &&
        <div
          className={classnames(styles.header, headerClassName)}>
          {header}
        </div>
      }
      {createElement(tabsContainerComponent)}
      <div className={classnames(styles.content, contentClassName)}>
        {children}
      </div>
    </div>
  );
});

export default FormLayout;
